import { render, staticRenderFns } from "./LogType.vue?vue&type=template&id=5ae20166&"
import script from "./LogType.vue?vue&type=script&lang=ts&"
export * from "./LogType.vue?vue&type=script&lang=ts&"
import style0 from "./LogType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports